/**
 * <TutorInvoiceRowSkeleton> — la forme d'une ligne de « Mes factures » pendant un chargement : la
 * date et les parties, le montant, puis les liens.
 */
import React from "react"

import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { CardListRow } from "../CardList"

export type TutorInvoiceRowSkeletonProps = {
    divided?: boolean
}

export function TutorInvoiceRowSkeleton(props: TutorInvoiceRowSkeletonProps) {
    return (
        <CardListRow divided={props.divided}>
            <Stack gap="2">
                <Row gap="3" justify="between" align="start">
                    <Stack gap="1">
                        <Skeleton textSize="text-lg" width={140} />
                        <Skeleton textSize="text-sm" width={210} />
                    </Stack>
                    <Skeleton textSize="text-lg" width={72} />
                </Row>
                <Row gap="4">
                    <Skeleton textSize="text-md" width={56} />
                    <Skeleton textSize="text-md" width={96} />
                </Row>
            </Stack>
        </CardListRow>
    )
}
